import { Package, Eye } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { getStatusBadge } from './helpers';

export function OrdersTable({ orders, onOpenDetails }) {
  if (orders.length === 0) {
    return (
      <div className="bg-white border border-slate-200 rounded-xl p-16 text-center">
        <div className="w-14 h-14 bg-slate-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
          <Package className="w-7 h-7 text-slate-300" />
        </div>
        <h3 className="text-base font-semibold text-slate-700 mb-1">Ingen bestillingar</h3>
        <p className="text-sm text-slate-400">Ingen bestillingar funne for valt filter</p>
      </div>
    );
  }

  return (
    <div className="bg-white border border-slate-200 rounded-xl overflow-hidden">
      <table className="min-w-full">
        <thead>
          <tr className="border-b border-slate-100 bg-slate-50/50">
            <th className="px-4 py-3 text-left text-[10px] font-semibold text-slate-500 uppercase tracking-wider">Bestilling</th>
            <th className="px-4 py-3 text-left text-[10px] font-semibold text-slate-500 uppercase tracking-wider">Kunde</th>
            <th className="px-4 py-3 text-left text-[10px] font-semibold text-slate-500 uppercase tracking-wider">Type</th>
            <th className="px-4 py-3 text-left text-[10px] font-semibold text-slate-500 uppercase tracking-wider">Lokalitet</th>
            <th className="px-4 py-3 text-left text-[10px] font-semibold text-slate-500 uppercase tracking-wider">Dato</th>
            <th className="px-4 py-3 text-left text-[10px] font-semibold text-slate-500 uppercase tracking-wider">Status</th>
            <th className="px-4 py-3"></th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          {orders.map(order => (
            <tr key={order.id} className="hover:bg-slate-50/50 transition-colors" data-testid={`order-row-${order.id}`}>
              <td className="px-4 py-3">
                <div className="text-sm font-medium text-slate-900">{order.order_number}</div>
                <div className="text-[11px] text-slate-400">
                  {new Date(order.created_at).toLocaleDateString('nb-NO', { day: 'numeric', month: 'short' })}
                </div>
              </td>
              <td className="px-4 py-3">
                <div className="text-sm text-slate-800">{order.contact_person || '—'}</div>
                <div className="text-[11px] text-slate-400">{order.contact_email || ''}</div>
              </td>
              <td className="px-4 py-3">
                <span className="text-xs font-medium text-slate-600">
                  {order.sample_type === 'algae' ? 'Alge' : 'Zooplankton'}
                </span>
              </td>
              <td className="px-4 py-3">
                <div className="text-sm text-slate-800 max-w-[180px] truncate">{order.location_name}</div>
              </td>
              <td className="px-4 py-3 text-sm text-slate-600">
                {new Date(order.preferred_date).toLocaleDateString('nb-NO', { day: 'numeric', month: 'short', year: 'numeric' })}
              </td>
              <td className="px-4 py-3">{getStatusBadge(order.status)}</td>
              <td className="px-4 py-3">
                <Button variant="ghost" size="sm" onClick={() => onOpenDetails(order)} className="h-7 text-xs text-teal-600 hover:text-teal-700 hover:bg-teal-50">
                  <Eye className="w-3.5 h-3.5 mr-1" /> Vis
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
